import { connect } from 'react-redux';

import get from 'lodash/get';

import PersonActionsLogComponent from '../components/PersonActionsLogComponent';

import { clearPerson, getPersonById } from '../../Person/actions';
import { clearPersonActionsLog, getPersonActionsLog } from '../actions';

import { getTodayCount } from '../../../utils';

const LIST_KEY = 'PersonActionsLog';

const mapStateToProps = (state) => {
  const items = get(state, 'carsonActivity.personActionsLog', {});
  const listParams = get(state, `lists.${LIST_KEY}`, {});
  const buildings = get(state, 'buildings', {});
  const person = get(state, 'person', null);
  return {
    listKey: LIST_KEY,
    listParams,
    items,
    buildings,
    person,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const personId = get(ownProps, 'match.params.id', null);
  return {
    onLoad: () => personId && getPersonById(dispatch, personId),
    getItems: (queryParams) => {
      if (!personId) {
        getPersonActionsLog(dispatch, queryParams, personId);
        getTodayCount(getPersonActionsLog, dispatch, queryParams, personId);
      }
    },
    onUnmount: () => {
      clearPersonActionsLog(dispatch);
      clearPerson(dispatch);
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PersonActionsLogComponent);
